import { onetCsvAttributionRows } from "@/lib/onetAttribution";

/**
 * Trigger a client-side CSV download.
 *
 * Pass `{ onetAttribution: true }` for any file built from O*NET-derived
 * content — USDOL/ETA require the attribution to travel with the data, so it is
 * appended as trailing rows rather than left on screen only.
 */
export function downloadCsv(
  filename: string,
  rows: (string | number)[][],
  options: { onetAttribution?: boolean } = {},
) {
  const escape = (cell: string | number) => {
    const s = String(cell ?? "");
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const all = options.onetAttribution ? [...rows, ...onetCsvAttributionRows()] : rows;
  const csv = all.map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
